import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        containerUl: '[js-hand-drawn-circle="container-ul"]',
        item: '[js-hand-drawn-circle="item"]',

        button: '[js-hand-drawn-circle="button"]',
        buttonContainer: '[js-hand-drawn-circle="button-container"]',
    }

    function init() {
        // if ( !document.querySelector(nodeSelectors.containerUl) && !document.querySelector(nodeSelectors.item) ) {
        //     return
        // }

        // js-hand-drawn-circle="item"
        let items = $(nodeSelectors.item);
        appendIcon(items)

        // js-hand-drawn-circle="button"
        let buttons = $(nodeSelectors.button);
        appendIcon(buttons)

        // js-hand-drawn-circle="container-ul"
        $(nodeSelectors.containerUl).each(function () {
            let ulItems = $(this).find('li a')

            appendIcon(ulItems)
        })

        // js-hand-drawn-circle="button-container"
        $(nodeSelectors.buttonContainer).each(function () {
            let buttons = $(this).find('button')

            appendIcon(buttons)
        })
    }

    function appendIcon(items) {
        $(items).each(function () {
            $(this).append(`
                <svg viewBox="0 0 194 101" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                    <path d="M137.359 16.8127C121.917 3.18709 97.9091 2.57325 78.5248 1.99026C56.8726 1.33907 31.0007 0.822342 13.3843 15.7725C-15.7088 40.4623 16.5805 67.2421 40.3636 78.2476C75.8177 94.6538 121.039 103.501 159.983 96.3856C172.401 94.1166 188.502 87.2405 191.968 72.9818C194.473 62.6784 186.749 47.1496 180.526 40.0864C147.717 2.84762 87.5133 5.07828 42.574 3.94058" stroke="white" stroke-opacity="0.7" stroke-width="3" stroke-linecap="round"/>
                </svg>
            `)
        })
    }


    return Object.freeze({
        init,
    })
}